import { ReceiptInfo } from './receipt-info'
import { ReceiptItem } from './receipt-item'

export class ReceiptPrototype {

  items: ReceiptItem[]
  info: ReceiptInfo

  constructor() {
    this.items = []
    this.info = new ReceiptInfo()
  }

  get summary(): any {
    return {
      subtotal: this.info.subtotal,
      tax: this.info.tax,
      total: this.info.total,
      preTaxCostFromItems: this.preTaxCostFromItems,
      total_count: this.total_count,
      avg_price: Math.round(this.info.subtotal / this.total_count),
      max_price: this.max_price,
      min_price: this.min_price,
      date: this.info.date,
      purchaser: this.info.purchaser,
      shipping_fee: this.someItemsShipped ? this.info.subtotal - this.preTaxCostFromItems : 0
    }
  }

  get total_count(): number {
    return this.items.reduce((acc, item) => acc + item.count, 0)
  }

  get max_price(): number {
    return this.items.reduce((acc, x) => x.pre_tax_price > acc ? x.pre_tax_price : acc, 0)
  }

  get min_price(): number {
    return this.items.reduce(
      (acc, x) => x.pre_tax_price < acc ? x.pre_tax_price : acc,
      this.items[0].pre_tax_price
    )
  }

  get preTaxCostFromItems(): number {
    return this.items.reduce((acc, x) => acc + x.pre_tax_price * x.count, 0)
  }

  get someItemsShipped(): boolean {
    return this.items.some(x => x.shipped)
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/receipt.prototype.ts